/* @flow */

import React, { Component } from 'react';
import { css, names } from 'linaria';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

import Colors from '../../constants/Colors';
import { Logo, Text } from '../core';
import MediaQueries from '../../constants/MediaQueries';
import SiteNavigation from './SiteNavigation';
import MobileNav from './MobileNav';
import withBreakpoint from '../withBreakpoint';
import withWindowDimensions from '../withWindowDimensions';
import ZIndex from '../../constants/ZIndex';

const LogoWrapper = function({ theme }) {
  return (
    <div className={Styles.Logo}>
      <Link to="/">
        <Logo theme={theme} />
      </Link>
    </div>
  );
};

class SiteHeader extends Component<
  {
    breakpoint: BreakpointSize,
    windowDimensions: { width: number, height: number },
    theme: 'light' | 'dark',
  },
  {
    transparentMobileBackground: boolean,
    mobileNavOpen: boolean,
  }
> {
  state = {
    transparentMobileBackground: true,
    mobileNavOpen: false,
  };

  componentDidMount() {
    this._onScroll();
    window.addEventListener('scroll', this._onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._onScroll);
  }

  _onScroll = () => {
    let transparentMobileBackground = window.pageYOffset === 0;
    if (transparentMobileBackground !== this.state.transparentMobileBackground) {
      this.setState({
        transparentMobileBackground,
      });
    }
  };

  _onMobileNavOpen = () => {
    this.setState({
      mobileNavOpen: true,
    });
  };

  _onMobileNavClose = () => {
    this.setState({
      mobileNavOpen: false,
    });
  };

  render() {
    let isSmallBreakpoint = this.props.breakpoint === 'small';
    let { theme, windowDimensions } = this.props;
    const { width } = windowDimensions;

    if (isSmallBreakpoint) {
      return (
        <div className={Styles.MobileRoot}>
          <header
            className={names(
              Styles.Container,
              Styles.MobileContainer,
              this.state.mobileNavOpen && Styles.MobileContainerNavOpen,
              ThemeStyles[theme].MobileContainer,
              this.state.transparentMobileBackground &&
                !this.state.mobileNavOpen &&
                ThemeStyles[theme].TransparentMobileBackground
            )}>
            <LogoWrapper theme={theme} />
            {!isSmallBreakpoint && (
              <div className={Styles.Tagline}>
                <Text color={ThemeStyles[theme].TaglineColor} size="18">
                  moving & delivery
                </Text>
              </div>
            )}
            <div className={Styles.Navigaton}>
              <MobileNav
                theme={theme}
                onOpen={this._onMobileNavOpen}
                onClose={this._onMobileNavClose}
              />
            </div>
          </header>
        </div>
      );
    } else {
      return (
        <header className={Styles.Container}>
          <LogoWrapper theme={theme} />
          {width > 1150 && (
            <div className={Styles.Tagline}>
              <Text color={ThemeStyles[theme].TaglineColor} size="18">
                moving & delivery
              </Text>
            </div>
          )}
          <div className={Styles.Navigaton}>
            <SiteNavigation theme={theme} />
          </div>
          <div className={names(Styles.BottomBorder, ThemeStyles[theme].BottomBorder)} />
        </header>
      );
    }
  }
}

const MobileHeight = 64;

const ThemeStyles = {
  light: {
    TaglineColor: Colors.Violet,
    MobileContainer: css`
      background-color: ${Colors.White};
    `,
    TransparentMobileBackground: css`
      background-color: ${Colors.opacity(Colors.White, 0)};
    `,
    BottomBorder: css`
      background-color: ${Colors.opacity(Colors.Black, 0.07)};
    `,
  },
  dark: {
    TaglineColor: Colors.White,
    MobileContainer: css`
      background-color: ${Colors.IndigoDark};
    `,
    TransparentMobileBackground: css`
      background-color: ${Colors.opacity(Colors.IndigoDark, 0)};
    `,
    BottomBorder: css`
      background-color: ${Colors.opacity(Colors.White, 0.07)};
    `,
  },
};

const Styles = {
  Container: css`
    align-items: center;
    display: flex;
    padding: 0 24px;
  `,
  MobileRoot: css`
    height: ${MobileHeight}px;
  `,
  MobileContainer: css`
    height: ${MobileHeight}px;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: background-color 0.2s;
    z-index: ${ZIndex.Highest};
  `,
  MobileContainerNavOpen: css`
    transition: none;
  `,
  Logo: css`
    flex: none;
    margin-right: 16px;
    width: 68px;
    ${MediaQueries.Medium} {
      width: 102px;
    }
  `,
  Tagline: css`
    flex: none;
  `,
  Navigaton: css`
    flex: 1;
  `,
  BottomBorder: css`
    bottom: 0;
    height: 1px;
    left: 24px;
    right: 24px;
    position: absolute;
  `,
};

export default compose(
  withBreakpoint,
  withWindowDimensions
)(SiteHeader);



// WEBPACK FOOTER //
// ./src/ui/components/chrome/SiteHeader.js